module.exports = __webpack_public_path__ + "img/dianchi-60.56571ed7.png";